// extracted by css-extract-rspack-plugin
export default {"inputNumber":"inputNumber-EUEDL"};